import { Component, Input, HostListener, ChangeDetectorRef, Renderer2, ViewChild, ElementRef, OnInit ,OnChanges,SimpleChanges} from '@angular/core'
import { AppState } from '../app.service'
import { Comment } from './comment.model'
import { Client } from '../client/client.model'
import { User } from '../user/user.model'
import { SessionService } from '../session/session.service'
import { CordovaService } from '../cordova.service'
import { ReplyService } from '../reply/reply.service'
import { MobileChatServiceService } from '../pages/mobile-chat-board/mobile-chat-service.service'
import { ToastrService } from 'ngx-toastr'
import { Apollo } from 'apollo-angular'
import { UserPublicProfileComponent } from '../components/user-public-profile/user-public-profile.component'
import { PopoverController } from '@ionic/angular'
import { MatMenu, MatMenuTrigger } from '@angular/material/menu'
import { I18n } from '../i18n.service'
import { KyperDataApiService } from '../services/kyper-data-api.service'
import { Path } from '../path/path-v2.model'
import { HomeUiService } from '../new-design/home-ui.service'

@Component({
  selector: 'first90-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit, OnChanges {
  @Input() inverted = false
  @Input() comment
  @Input() voteCounts: number
  @Input() repliesTree;
  @Input() postId: number
  @Input() check;
  @ViewChild('btn') btn: ElementRef;
  @ViewChild('textContainer') textContainer: ElementRef;
  @ViewChild('disableListener') disableListener: ElementRef

  isMobile: boolean
  user: User
  client: Client
  isCommentPosted
  showMenu =false;
  selected: boolean = false
  voteLoading: boolean = false
  state: boolean = false;
  maxHeight: number = 45;
  path: Path

  //set these to false to get the height of the expended container 
  public isCollapsed: boolean = false;
  public isCollapsable: boolean = false;
  constructor(private appState: AppState, public sessionService:SessionService,private cordovaService: CordovaService,  private cdRef: ChangeDetectorRef,private replyService: ReplyService,
    private mobileService:MobileChatServiceService,
    private toasterService:ToastrService,
    private apollo:Apollo,
    private popoverController:PopoverController,
    private render: Renderer2,
    private i18n: I18n,
    private elementRef: ElementRef,
    private kyperService: KyperDataApiService,
    public homeUiService: HomeUiService
    ) {
    this.client = this.appState.get('currentClient')
    this.user = this.appState.get('currentUser')
    this.path = this.appState.get('currentPath')
    this.isMobile = this.appState.get('isMobile')
    this.isCommentPosted=  this.appState.get('isReplyAnimationApplied')   
  }
  ngOnInit(): void {
    this.isCommentPosted=  this.appState.get('isReplyAnimationApplied')
  }
  ngOnChanges(changes: SimpleChanges): void {}
  get commentUser() {
    return this.homeUiService.liveProfileUser(this.comment?.user)
  }

  async openUserInfo(ev, userData): Promise<void> {
    const popover = await this.popoverController.create({
      component: UserPublicProfileComponent,
      event: ev,
      mode:'ios',
      translucent: false,
      componentProps: {'user': userData}
    });
    await popover.present();
   
  }
  public getIcon( fileName ) {
    const extension = fileName.split( '.' ).pop()
    let icon = ''

    switch ( extension ) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        icon = 'glyphicon-picture'
        break
      case 'mp4':
      case '3gp':
      case 'mpg':
      case 'mpeg':
      case 'avi':
      case 'flv':
        icon = 'glyphicon-film'
        break
      case 'mp3':
        icon = 'glyphicon-headphones'
        break
      case '7z':
      case 'rar':
      case 'zip':
        icon = 'glyphicon-folder-open'
        break
      default:
        icon = 'glyphicon-file'
    }

    return icon
  }
  ngAfterViewInit(){
    try {
      if (!this.isMobile) {
        document.getElementById('social-icons').classList.add('desktop');
      }
    } catch (error) { }
    
    setTimeout(() => {    
       if(this.isCommentPosted){
        document.getElementById('desktopComment').classList.add('reply-animation-class');  
        this.appState.set('isReplyAnimationApplied',false)
      }
      },1);
      setTimeout(() => {
          if(this.isCommentPosted){
            document.getElementById('desktopComment').classList.remove('reply-animation-class');
        }
      },1500);
  }
  textExpand(val) {
    if(val){
      this.render.removeClass(this.textContainer.nativeElement, 'reply-text');
      this.isCollapsed = false;
      this.isCollapsable = true;
    }
    else {
      this.render.addClass(this.textContainer.nativeElement, 'reply-text');
      this.isCollapsed = true;
      this.isCollapsable = true;
    }
    this.cdRef.detectChanges();
  }
  doLikeUnlike() {
    
    this.render.addClass(this.btn.nativeElement, 'bounce');
    if (this.btn.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'), "name", 'star')
    }
    else {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'), "name", 'star-outline')

    }
    setTimeout(() => {
      this.render.removeClass(this.btn.nativeElement, 'bounce');
    }, 200);
  }

  getUserName(user){
    try {
          return user.firstName+" "+user.lastName 
    } catch (error) {
      
    }
  }

  toggleVote(comment) {
    console.log("🚀 ~ CommentComponent ~ toggleVote ~ comment:", comment)
    if (comment.user.id === this.user.id) {
      return false
    }
    
      this.onBounce();
   
    this.voteLoading = true
    comment.hasVoted = !comment.hasVoted
     if(!comment.replyVotesCount) {
      comment.replyVotesCount =0
    }
    comment.replyVotesCount += comment.hasVoted ? 1 : -1
    this.cdRef.detectChanges()
    let likesData = {
      // user_id: this.user.id,
      path_id: this.path.id,
      post_id: comment.id,
      screen_content_id: comment.screenContentId
    }
    this.kyperService.postKyperUserLikes(likesData).subscribe({
      next: (res) => {
        this.voteLoading = false;
        this.cdRef.detectChanges();
      },
      complete: () => {
        this.voteLoading = false;
        this.cdRef.detectChanges();
      },
      error: () => {
        this.voteLoading = false;
      }
    });
  }

onBounce() {
  this.render.addClass(this.btn.nativeElement, 'bounce');
  if(this.btn.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
    this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star')
  }
  else {
    this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star-outline')

  }
  setTimeout(() => {
    this.render.removeClass(this.btn.nativeElement, 'bounce');
  }, 200);
}
  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }

  deletePost(comment){
    let input ={
      screen_content_id:comment.screenContentId,
      root_id: comment.rootId,
      reply_level: 2,
      reply_id: comment.id
    }
    this.mobileService.deletePost(input).subscribe(
      response => {
          console.log(response);
          var test = this.appState.get('currentPath')
          console.log("deleted",test);
          this.appState.set('commentDeleted', true)
          // Report the deleted sub-reply's OWN id (not its parent's rootId). The list
          // components' removeDeletedComment() removes whatever id it's given: a top-level
          // id deletes that whole comment, so passing rootId here wiped out the parent and
          // its siblings instead of just this sub-reply.
          this.appState.set('deletedPostId', comment.id);
          // Scope the global delete signal to the owning post so its list instance can consume it even
          // when the deleted sub-reply isn't in that instance's loaded tree (prevents the flag from
          // lingering set forever). See ngDoCheck in the *-comment-list-web components.
          this.appState.set('deletedFromScreenContentId', comment.screenContentId);
          this.appState.set("repliesTreeObject", this.repliesTree);
          this.cdRef.detectChanges()
          this.toasterService.success(this.i18n.t('Comment deleted successfully.'))
      },
      error =>{
        console.log(error);
      }
    )
  }

  refresh() {
    this.appState.refreshMainComponent.emit();
  }


  copyMessage(val: string,comment: any){
    try {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toasterService.success(this.i18n.t("Copied to clipboard!"));
      this.deletePost(comment)
    }catch{
      this.toasterService.warning(this.i18n.t("Not able to copy and delete!"));
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.disableListener?.nativeElement.contains(event.target)) {
      this.showMenu = !this.showMenu;
    }
    else {
      this.showMenu =false;
    }
  }
}
